'use client';
import React from 'react';

import styled from 'styled-components';

import AddCommentForm from './AddCommentForm';
import CommentsCount from './CommentsCount';
import { CommentsSectionContextProvider } from './CommentsSectionProvider';
import LeaveCommentButton from './LeaveCommentButton';
import Anchor from '@/ui/components/Anchor';
import Comments from '@/ui/components/Comments';
import { device } from '@/ui/styles/breakpoints';

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2.5rem;
  align-items: start;
  width: 100%;
  overflow: scroll-y;
`;

const CommentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.88rem;
  width: 100%;
  flex-grow: 1;

  @media ${device.max.md} {
    h3 {
      display: none !important;
    }
  }
`;

export default function CommentSection({ comments, commentsInfo, postId }) {
  const parentRef = React.useRef(null);

  return (
    <CommentsSectionContextProvider
      postId={postId}
      serverFetchedComments={comments}
    >
      <Anchor id="comments-section">
        <SectionWrapper ref={parentRef}>
          <CommentsWrapper>
            <CommentsCount count={commentsInfo?.total_items} />
            <AddCommentForm />
            <Comments />
          </CommentsWrapper>
          <LeaveCommentButton />
        </SectionWrapper>
      </Anchor>
    </CommentsSectionContextProvider>
  );
}
